var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityDesignatedDropOffPoint = function SvgAccessibilityDesignatedDropOffPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M22.125 22.011v2.474a1.08 1.08 0 0 1-1.076 1.076H19.67a1.08 1.08 0 0 1-1.076-1.076v-2.474m10.347-.137H18.085a.806.806 0 0 1-.808-.807v-4.328c0-.79.208-1.565.603-2.249l1.61-2.786m9.451 7.846H17.278m11.708-7.841h-9.421m9.452 5.775H27.13m-7.565-5.865 2.462-6.374c.202-.519.7-.86 1.257-.862h5.701"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M20.03 15.376V17a.54.54 0 0 0 .539.539h3.855c.297 0 .538-.24.538-.538v-.675a.54.54 0 0 0-.374-.512l-3.855-.945a.54.54 0 0 0-.703.507m8.987.519H27.13m-6.408-7.309-2.758-2.83a1.5 1.5 0 0 0-1.078-.462h-4.161v13.439h4.243m2.718-7.024h-6.63m1.161 1.611h1.224m13.5 12.24H.983"
  }))));
};
export default SvgAccessibilityDesignatedDropOffPoint;